<div class="info">
    <a href=""><h4>> Welcome</h4></a>
    <a href="/product" style="pointer-events: none; color: grey"><h4>> Product</h4></a>
    <a href="/about" style="pointer-events: none; color: grey"><h4>> About</h4></a>
    <a href="mailto:amine.aouini@deepxp.io"><h4> > Contact</h4></a>
</div>